(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crownlab-back"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.getElementById('crownlab-back');
    if (!button) return;
    const validStoreUrl = (value) => {
      try {
        const url = new URL(value);
        return url.origin === location.origin && !/^\/(checkouts?|account)(\/|$)/.test(url.pathname);
      } catch { return false; }
    };
    let safeBack = false;
    try {
      const marker = history.state?.crownlabBack;
      if (marker && marker.url === location.href) {
        safeBack = marker.safe;
      } else {
        safeBack = validStoreUrl(document.referrer) &&
          sessionStorage.getItem('crownlabLastPage') === document.referrer;
        history.replaceState(
          { ...(history.state || {}), crownlabBack: { url: location.href, safe: safeBack } },
          ''
        );
      }
      sessionStorage.setItem('crownlabLastPage', location.href);
    } catch {}
    window.addEventListener('pageshow', () => {
      try { sessionStorage.setItem('crownlabLastPage', location.href); } catch {}
    });
    button.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      let previousIsStore = safeBack;
      if (window.navigation?.currentEntry) {
        const entries = window.navigation.entries();
        const index = entries.findIndex((entry) => entry.key === window.navigation.currentEntry.key);
        previousIsStore = index > 0 && validStoreUrl(entries[index - 1].url);
      }
      if (previousIsStore && history.length > 1) {
        event.preventDefault();
        history.back();
      }
    });
    let frame;
    const position = () => {
      frame = null;
      let bottom = 0;
      document.querySelectorAll('#header-group, header-component').forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (rect.top < innerHeight && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
      });
      button.style.setProperty('--crownlab-back-top', Math.min(bottom + 10, Math.max(10, innerHeight - 64)) + 'px');
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(position); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    const header = document.querySelector('#header-group');
    if (header && window.ResizeObserver) new ResizeObserver(schedule).observe(header);
    position();
  })();
  } catch(e) { console.error(e); }
})();

})();
